<template>
  <div>
    <b-card>
      <b-alert variant="danger" :show="errors.length > 0">
        <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
      </b-alert>
      <b-form @submit.stop.prevent="onSubmit">
        <div>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                label="شماره کارت بانکی: "
                label-for="input-1"
              >
                <b-input
                  style="word-spacing: 8px"
                  maxlength="16"
                  class="text-right ltr"
                  id="input_card_iban"
                  v-model="Input.cardnumber"
                  placeholder="---- ---- ---- ---- ----"
                  required
                ></b-input>
              </b-form-group>
            </b-col>
            <b-col> </b-col>
            <b-col> </b-col>

            <b-col> </b-col>
          </b-row>
        </div>

        <br />
        <b-button type="submit" class="mr-3" variant="success"
          >استعلام</b-button
        >
      </b-form>
      <div class="col-md-12" v-if="estelamResult != null">
        <br />
        <br />
        <h3>نتیجه استعلام</h3>
        <b-form-group label="شماره کارت:">
          <div class="form-control">
            {{ estelamResult.destCard }}
          </div>
        </b-form-group>
        <b-form-group label="نام صاحب کارت:">
          <div class="form-control">
            {{ estelamResult.name }}
          </div>
        </b-form-group>
        <b-form-group label="نتیجه استعلام:">
          <div class="form-control">
            {{ estelamResult.description }}
          </div>
        </b-form-group>      
      </div>
    </b-card>
  </div>
</template>

<style>
.aligner {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "@/helpers/httpHelper";
import persianDate from "../../helpers/persianDate";
import MDDropdown from "../../components/MDDropdown";
export default {
  name: "CardInquiry",
  components: {
    persianDate,
    MDDropdown,
  },
  data: function () {
    return {
      estelamResult: null,
      errors: [],
      Input: {
        cardnumber: "",
      },
    };
  },

  methods: {
    onSubmit(evt) {
      this.errors = [];

      httpHelper
        .postData("finnotech/cardinquiry", this.Input)
        .then((response) => {
          if (response.success) {
            if (response.result.status) {
              this.estelamResult = response.result.data;
            } else {
              this.estelamResult = null;
              this.errors.push(response.result.data.error.message);
            }
          } else {
            for (var key in response.error) {
              response.error[key].forEach((element) => {
                this.errors.push(element);
              });
            }
          }
        });
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "تایید مدارک",
        route: "/getinfowithiban",
      },
      {
        title: "استعلام کارت بانکی",
      },
    ]);
  },
};
</script>
